import { getMessages } from '../../../../../../../store/constants';

export const NOTIFY_SELECT_GROUP_BOARD = getMessages().getText('notify.select.group.card');
export const NOTIFY_SELECT_GROUP_OTHER = getMessages().getText('notify.select.group.other');
